import { useEffect } from 'react';

import { Button } from 'components/Button/Button';
import { Tooltip } from 'components/Tooltip/Tooltip';
import { useCurrentSavedSearch } from 'modules/search/hooks/useCurrentSavedSearch';
import { userDashboardSavedItemsRoute } from 'modules/userDashboard/routing/userDashboard.routes';
import {
  useRecentlySavedSearchId,
  userDashboardDismissRecentlySavedSearch,
} from 'modules/userDashboard/zustand-stores/userDashboardSavedSearchesStore';
import { trackClicked } from 'utils/analytics/track/trackClicked';
import { useModal } from 'zustand-stores/modalStore';

import { SaveSearchButtonHolder } from './SaveSearchButton.styled';
import { SaveSearchButtonTooltip } from './SaveSearchButtonTooltip';

type Props = {
  saveSearch: () => Promise<void>;
};

export function SaveSearchButton({ saveSearch }: Props) {
  const { savedSearch } = useCurrentSavedSearch();

  const { recentlySavedSearchId } = useRecentlySavedSearchId();

  useEffect(
    () => () => {
      userDashboardDismissRecentlySavedSearch();
    },
    [],
  );

  const { modal } = useModal();

  if (savedSearch) {
    return (
      <SaveSearchButtonHolder data-qa-id="save-search">
        <Tooltip
          content={
            <SaveSearchButtonTooltip
              savedSearch={savedSearch}
              onSavedOrDismissed={() =>
                userDashboardDismissRecentlySavedSearch()
              }
            />
          }
          size="large"
          placement="bottom-left"
          tooltipWidth="270px"
          renderCondition={savedSearch.id === recentlySavedSearchId && !modal}
          variant="brand-green"
          withArrow={false}
          closeable
          onClose={() => userDashboardDismissRecentlySavedSearch()}
        >
          <Button
            type="link"
            icon={{ name: 'bookmark', type: 'normalized' }}
            variant="secondary"
            href={userDashboardSavedItemsRoute.with({ tab: 'SEARCH' })}
            data-qa-id="save-search"
          >
            {getText('My Saved Searches')}
          </Button>
        </Tooltip>
      </SaveSearchButtonHolder>
    );
  }

  return (
    <Button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        trackClicked('Get Email Alerts');
        void saveSearch();
      }}
      icon={{ name: 'bookmark', type: 'normalized' }}
      variant="secondary"
      data-qa-id="save-search"
    >
      {getText('Save Search')}
    </Button>
  );
}
